<nav class="nav nav-pills flex-column" id="admin-menu">
    <a *ngFor="let item of navItems"
       class="nav-item nav-link"
       id="{{item.id}}-tab-menu"
       [class.active]="currentTab == item.id"
       [routerLink]="['/admin/' + item.id]">
        {{item.title}}
    </a>
</nav>
